module.exports = __webpack_public_path__ + "static/media/21.13a2b757.jpg";